import React from "react";
import { Dialog } from 'primereact/dialog';
function MeetingConfrimCreate({
    open = false,
    onClose = () => console.log('onClose'),
}) {


    return (
        <Dialog visible={open} style={{ width: '500px' }} onHide={() => onClose()} draggable={false} resizable={false} closable={false}>
            <div className="bModal bCard" id="confirmModal-cancel" style={{ display: 'block' }}>
                <div className="closeBtn" onClick={onClose}></div>
                <div className="bInner">
                    <div className="bTitle">
                        <span>
                            จองนัดหมายสำเร็จ
                        </span>

                    </div>
                    <div className="bBtn">
                        <button
                            className="btn outline btnCloseModal"
                            onClick={onClose}
                        >
                            ตกลง
                        </button>
                    </div>
                </div>
            </div>
        </Dialog>
    );
}

export default MeetingConfrimCreate;
